import { jsxs as i, jsx as l } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import { w as r } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import s from "../../packages/basic/dist/es/components/ReoIcon/ReoIcon.mjs";
import c from "../../packages/basic/dist/es/components/ReoBalloon/ReoBalloon.mjs";
import "../../packages/basic/dist/es/components/ReoButton/index.mjs";
import "../../packages/basic/dist/es/components/ReoCheckbox/index.mjs";
import "../../packages/basic/dist/es/components/ReoLink/ReoLink.mjs";
import "../../packages/basic/dist/es/_virtual/jsx-runtime.mjs";
import "../../packages/basic/dist/es/depend/classnames/index.mjs";
import "../../packages/basic/dist/es/assets/css/globalTheme.mjs";
import "../../packages/basic/dist/es/assets/css/themes/template/templateMap.mjs";
import "../../packages/basic/dist/es/components/ReoTabs/ReoTabTree.mjs";
import "../../packages/basic/dist/es/components/ReoInput/index.mjs";
import "../../packages/basic/dist/es/components/ReoSelect/ReoSelect.mjs";
import "../../packages/basic/dist/es/components/ReoPopup/ReoPopup.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/UploadList.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/const.mjs";
import "../../packages/basic/dist/es/depend/rc-upload/es/Upload.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/DraggedUploadList.mjs";
import "../../packages/basic/dist/es/components/ReoAccordion/AccordionItem.mjs";
import "../../packages/basic/dist/es/depend/swiper/swiper-react.mjs";
import "../../packages/basic/dist/es/Basic/LoadingBar/LoadingBar.mjs";
import "../../packages/basic/dist/es/components/ReoMessage/ReoMessage.mjs";
import "../../packages/basic/dist/es/components/ReoForm/index.mjs";
import { balloon as C, overlay as N, balloonContent as u } from "./css/InputBalloon.css.mjs";
import e from "../../depend/classnames/index.mjs";
import { defaultProps as y } from "./const.mjs";
const d = (t) => {
  const m = o.useMemo(() => e(
    C,
    t.balloonClassName
  ), [t.balloonClassName]), a = o.useMemo(() => e(
    N,
    t.overlayClassName
  ), [t.overlayClassName]), n = o.useMemo(() => e(
    u,
    t.balloonContentClassName
  ), [t.balloonContentClassName]);
  return /* @__PURE__ */ i(
    "div",
    {
      className: t.className,
      style: t.style,
      children: [
        t.text,
        t.balloonText ? /* @__PURE__ */ l(
          c,
          {
            type: t.type,
            contentBackgroundColor: t.contentBackgroundColor ?? "#000814",
            placement: t.placement ?? "topCenter",
            trigger: t.trigger,
            className: m,
            style: t.balloonStyle,
            overlayClassName: a,
            content: t.balloonText,
            contentClassName: n,
            children: /* @__PURE__ */ l(
              s,
              {
                className: t.iconClassName,
                style: t.iconStyle,
                width: t.iconWidth ?? y.iconWidth,
                name: "icon-icon_question"
              }
            )
          }
        ) : null
      ]
    }
  );
}, J = r(d, {});
export {
  J as default
};
//# sourceMappingURL=InputBalloon.mjs.map
